import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border: solid 2px ${props => props.theme.colors.light};
  border-radius: 4px;
  overflow: hidden;
  .react-player{
    position: relative;
    padding-top: 56.25%;

    video{
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;
